import {Grommet, Main, Heading, Text} from "grommet";
import GraphTable from "./Components/GraphTable/GraphTable";
import Table from "./Components/Table/Table";

import overallData from './Data/scorecards_overall.json';
import governanceData from './Data/scorecards_governance.json';
import servicesData from './Data/scorecards_services.json';
import BoxRow from "./Components/TrBoxes";
import TopRow from "./Components/TopRow";

const url = window.location.href.split('/');
let state = url[url.length-1].split('=')[1].toUpperCase();
let STATE = '';
switch(state.toLowerCase()) {
    case "va": STATE = "Virginia"; break;
    case "nc": STATE = "North Carolina"; break;
    case "ky": STATE = "Kentucky"; break;
    case "ga": STATE = "Georgia"; break;
    case "tn": STATE = "Tennessee"; break;
    case "al": STATE = "Alabama"; break
    case "ms": STATE = "Mississippi"; break
}

const overall = overallData.filter( datum => {
    return datum.State_Abbr === state
})

const governance = governanceData.filter( datum => {
    return datum.State_Abbr === state
})

const services = servicesData.filter( datum => {
    return datum.State_Abbr === state
})

const theme = {
    global: {
        colors: {
            "appGreen": "#448325",
            "appBlue": "#132DAD",
        },
        font: {
            family: 'Roboto',
            size: '18px',
            height: '20px',
        },
    },
    breakpoints: {
        small: {
            value: 600
        },
        medium: {},
        large: {},

    }
};
const servicesHeaders = [
    'Overall Member Services (50)',
    'Medical Exemption from Disconnection (5)',
    'Spraying Opt-Out (5)',
    'Broadband Internet (5)',
    'Low Fixed Fees (5)',
    'Rooftop Solar Policy (10)',
    'Community Solar Option (10)',
    'Energy Efficiency Financing (10)'
]

const governanceRowHeaders = ['Overall_Governance', 'Board_Meetings','Board_Access','Dem_Control_Elections', 'Dem_Control_Bylaws', 'Governance_Financial_Transparency'];
const governanceHeaders = ['Overall Governance (50)', 'Board Meeting Transparency (16)', 'Access to Board Members (4)', 'Democratic Elections (14)', 'Democratic Bylaws (8)', 'Financial Transparency (8)'];
const servicesRowHeaders = ['Overall_Services', 'Medical_Exemption', 'Right_of_Way', 'Broadband', 'Fixed_Fees', 'DE_Policy', 'Community_Solar', 'EE_Financing'];


function App() {
  return (
      <Grommet theme={theme}>
        <Main pad="large" alignContent="center" align="center">
            <Heading style={{margin: "auto", textAlign: 'center'}} color="appBlue">
                {STATE} Electric Cooperatives
            </Heading>
            <TopRow state={state}/>
            <hr width="100%" color="#448325"/>
            <Text>
                Compare the overall performance of {STATE} electric cooperatives or scroll down to see how they compare on various measures of democratic governance and member services. Click on a co-op’s name to view its detailed report card.
            </Text>
            <GraphTable data={overall} title="Overall Score" total="100" score="Overall_Score" />
            <br />
            <Table title="Governance" state={state} data={governance} rowHeaders={governanceRowHeaders} headers={governanceHeaders}/>
            <br />
            <Table title="Members Services" state={state} data={services} rowHeaders={servicesRowHeaders} headers={servicesHeaders}/>
            <br />
            <hr width="100%" color="#448325"/>
            <BoxRow state={state}/>
        </Main>
      </Grommet>
  );
}

export default App;